import React, { useState } from 'react';
import { Row, Col, Button, Progress, Alert } from 'reactstrap';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';

export function UploadPhotoPage() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [message, setMessage] = useState('');
  const username = localStorage.getItem('username');

  const onDrop = (acceptedFiles) => {
    setSelectedFile(acceptedFiles[0] || null);
    setMessage('');
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: 'image/*'
  });

  const handleUpload = async () => {
    if (!selectedFile || !username) {
      setMessage("Please select a file.");
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("username", username);

    // Retrieve the token from localStorage
    const token = localStorage.getItem('idToken');

    setUploading(true);
    setMessage('');
    setUploadProgress(0);
    try {
      const response = await axios.post("http://localhost:8001/api/upload-photo", formData, {
        headers: { 
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
        onUploadProgress: event => {
          const percent = Math.round((event.loaded * 100) / event.total);
          setUploadProgress(percent);
        }
      });
      setMessage(response.data.message || "Upload successful");
    } catch (error) {
      console.error("Error uploading file:", error);
      setMessage("Failed to upload file.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="page-content">
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Upload a Photo for Audit</h4>
          </div>
        </Col>
      </Row>
      <div 
        {...getRootProps()} 
        style={{
          border: '2px dashed #0d6efd',
          padding: '40px',
          textAlign: 'center',
          borderRadius: '8px',
          backgroundColor: isDragActive ? '#e3f2fd' : '#fafafa',
          color: '#0d6efd',
          cursor: 'pointer'
        }}
      >
        <input {...getInputProps()} />
        {selectedFile ? (
          <h5>Selected File: {selectedFile.name}</h5>
        ) : (
          <h5>Drag &amp; drop a file here, or click to select one</h5>
        )}
      </div>
      <Button color="primary" className="w-100 mt-3" onClick={handleUpload} disabled={uploading || !selectedFile}>
        {uploading ? "Uploading..." : "Upload"}
      </Button>
      {uploading && (
        <Progress value={uploadProgress} className="mt-2" />
      )}
      {message && (
        <Alert color={message.toLowerCase().includes("fail") || message.toLowerCase().includes("please") ? "danger" : "success"} className="mt-3">
          {message}
        </Alert>
      )}
    </div>
  );
}
